import React from "react";
import {
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  CircularProgress,
  DialogContent,
  IconButton,
} from "@mui/material";
import { Button, TabButton, Icon } from "../index";
import saynLogo from "../../assets/new-images/sayn-institute.png";
import styles from "./FormContainer.module.css";

const FormContainer = ({
  title,
  subtitle,
  children,
  actions,
  onClickRight,
  rightButtonText,
  onClickLeft,
  hideRightButton,
  hideLeftButton,
  disableLeftButton,
  leftButtonText,
  translate,
  loading,
  actionsOnTop,
  tabs,
  error,
  message,
  fullHeight,
  disabled,
  logo,
  className,
  onClose,
  showCloseIcon,
}) => {
  const renderActions = () => {
    if (actions === false || loading) return null;
    if (React.isValidElement(actions)) return actions;

    return (
      <DialogActions
        className={`${styles.formActions} ${actionsOnTop ? styles.actionsTop : ""}`}
      >
        {!hideLeftButton && (
          <Button
            className={styles.cancelButton}
            variant="outline-grey"
            onClick={onClickLeft}
            disabled={disabled || disableLeftButton}
            data-testid="dialog-left-button"
          >
            {leftButtonText || translate("cancel")}
          </Button>
        )}
        {!hideRightButton && (
          <Button
            className={styles.nextButton}
            variant="grey-light"
            onClick={onClickRight}
            disabled={disabled}
            data-testid="dialog-right-button"
          >
            {rightButtonText || translate("sd_next")}
          </Button>
        )}
      </DialogActions>
    );
  };

  return (
    <>
      {logo && (
        <Box className={styles.logo}>
          <img src={saynLogo} alt="Logo" />
        </Box>
      )}
      {title && (
        <DialogTitle className={styles.dialogHeader}>
          <Box className={styles.headerMain}>
            <Typography className={styles.header}>
              {title}
              {subtitle && <span className={styles.headerLight}>{subtitle}</span>}
            </Typography>
            {tabs && (
              <Box className={styles.tabs}>
                {tabs.map((tab, index) => (
                  <TabButton
                    key={index}
                    icon={tab.icon}
                    size="small"
                    title={tab.title}
                    isSelected={tab.isSelected}
                    onClick={tab.onClick}
                    data-testid={tab.code || `tab-${index}`}
                  />
                ))}
              </Box>
            )}
            {actionsOnTop && renderActions()}
          </Box>
          {showCloseIcon && onClose && (
            <IconButton
              onClick={onClose}
              className={styles.closeButton}
              data-testid="dialog-close-button"
              aria-label={translate("close_dialog")}
            >
              <Icon icon="close" color="black" />
            </IconButton>
          )}
        </DialogTitle>
      )}
      <DialogContent
        className={`${styles.dialogBody} ${error || message ? styles.contain : ""} ${className || ""}`}
      >
        {loading ? (
          <Box className={styles.loading} data-testid="dialog-loading">
            <CircularProgress />
            <Typography>{translate("loading")}</Typography>
          </Box>
        ) : error ? (
          <Box className={styles.message} data-testid="dialog-error-message">
            <Typography className={styles.messageTitle}>
              {translate("error_title")}
            </Typography>
            <Typography className={styles.messageText}>
              {translate("error_description")}
            </Typography>
          </Box>
        ) : message ? (
          <Box
            className={`${styles.message} ${fullHeight ? styles.fullHeight : ""}`}
            data-testid="dialog-message"
          >
            {message.title && (
              <Typography className={styles.messageTitle}>{message.title}</Typography>
            )}
            {message.subtitle && (
              <Typography className={styles.messageText}>{message.subtitle}</Typography>
            )}
            {children}
          </Box>
        ) : (
          children
        )}
      </DialogContent>
      {!actionsOnTop && renderActions()}
    </>
  );
};

export default FormContainer;
